module.exports = __webpack_public_path__ + "img/carrousel-rad-con-arco-3.7020b30f.png";